// ViewToggle.js — ambient-only segmented control to flip the tray between
// the Agent (queue + chat) and the Timeline (vertical MultiRecord++) views,
// so an employee can demo whichever is relevant. Only rendered when the
// ambient flag is on (those users get both). Design: docs/comprehend-live-v05.md.
import React from 'react';
import { useComprehendLive } from 'agent/useComprehendLive';
import { T } from './liveTheme';

const ViewToggle = () => {
  const { state, actions } = useComprehendLive();
  const view = state.panelView === 'timeline' ? 'timeline' : 'agent';
  const opt = (key, label) => {
    const active = view === key;
    return (
      <span
        key={key}
        role="button"
        onClick={(e) => {
          e.stopPropagation();
          if (!active) actions.togglePanelView();
        }}
        style={{
          padding: '2px 8px',
          fontSize: 9,
          fontWeight: 700,
          letterSpacing: '.4px',
          borderRadius: 7,
          cursor: 'pointer',
          background: active ? T.surfaceCard : 'transparent',
          color: active ? T.textPrimary : T.textFaint,
        }}
      >
        {label}
      </span>
    );
  };
  return (
    <div
      title="Switch view (demo)"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 2,
        padding: 2,
        borderRadius: 9,
        border: `1px solid ${T.border}`,
        flexShrink: 0,
      }}
    >
      {opt('agent', 'AGENT')}
      {opt('timeline', 'TIMELINE')}
    </div>
  );
};

export default ViewToggle;
